/* Lunaire - garante que o "Fechar pedido" do carrinho lateral va para o checkout da Yampi */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout');
    if (!btn || btn.classList.contains('ymp_elem_mainBtn')) return;
    if (typeof window.yampiClick !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.yampiClick();
  }, true);
})();
